import Bugsnag from "@bugsnag/js";

const FIREBASE_ERROR_KEYS = {
  "auth/invalid-email": "auth.firebaseErrors.invalidEmail",
  "auth/user-disabled": "auth.firebaseErrors.userDisabled",
  "auth/user-not-found": "auth.firebaseErrors.userNotFound",
  "auth/wrong-password": "auth.firebaseErrors.wrongPassword",
  "auth/invalid-credential": "auth.firebaseErrors.invalidCredential",
  "auth/email-already-in-use": "auth.firebaseErrors.emailAlreadyInUse",
  "auth/weak-password": "auth.firebaseErrors.weakPassword",
  "auth/operation-not-allowed": "auth.firebaseErrors.operationNotAllowed",
  "auth/too-many-requests": "auth.firebaseErrors.tooManyRequests",
  "auth/network-request-failed": "auth.firebaseErrors.networkRequestFailed",
  "auth/requires-recent-login": "auth.firebaseErrors.requiresRecentLogin",
  "auth/popup-closed-by-user": "auth.firebaseErrors.popupClosedByUser",
  "auth/popup-blocked": "auth.firebaseErrors.popupBlocked",
  "auth/cancelled-popup-request": "auth.firebaseErrors.cancelledPopupRequest",
  "auth/account-exists-with-different-credential":
    "auth.firebaseErrors.accountExistsWithDifferentCredential",
  "auth/credential-already-in-use":
    "auth.firebaseErrors.credentialAlreadyInUse",
  "auth/expired-action-code": "auth.firebaseErrors.expiredActionCode",
  "auth/invalid-action-code": "auth.firebaseErrors.invalidActionCode",
  "auth/missing-email": "auth.firebaseErrors.missingEmail",
  "auth/missing-password": "auth.firebaseErrors.missingPassword",
  "auth/internal-error": "auth.firebaseErrors.internalError",
  "auth/unauthorized-domain": "auth.firebaseErrors.unauthorizedDomain",
  "auth/web-storage-unsupported": "auth.firebaseErrors.webStorageUnsupported",
};

export function getFirebaseErrorMessage(error, t) {
  const key = FIREBASE_ERROR_KEYS[error?.code];
  if (key) {
    return t(key);
  }
  if (Bugsnag.isStarted?.()) {
    Bugsnag.notify(error instanceof Error ? error : new Error(String(error)));
  }
  return t("auth.firebaseErrors.unknown", {
    error: error?.message || String(error),
  });
}

export function isFirebaseErrorCode(error, code) {
  return error?.code === code;
}
